






























































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import CollapsableMenu from '@/components/CollapsableMenu.vue'
import { Modules } from '@/models/Modules'
import { Pages } from '@/models/Pages'
import Loader from '@/components/Loader.vue'
import SwitchAccounts from '@/components/SwitchAccounts.vue'

@Component({
	components: {
		CollapsableMenu,
		Loader,
		SwitchAccounts,
	},
})
export default class Main extends Vue {
	// protected modules: Modules = new Modules()
	protected pages: Pages = new Pages()
	private showSidebar: boolean = false
	private width = window.innerWidth

	@Watch('width', { immediate: true })
	private onWidthChange(val: number) {
		this.$store.commit('windowWidth', val)
		if (this.isMobile) {
			this.showSidebar = false
		} else {
			this.showSidebar = true
		}
	}

	@Watch('$route')
	private onRouteChange() {
		if (this.isMobile) {
			this.showSidebar = false
		}
	}

	get modules() {
		return this.$store.getters.modules
	}

	get isMobile() {
		return this.$store.getters.isMobile
	}

	get contentWidth() {
		if (this.showSidebar) {
			return `${this.width - 250}px`
		}
		return `${this.width}px`
	}

	get loading() {
		return this.$store.getters.loading
	}

	get pageNavigationList() {
		return this.pages.models.filter((page: any) => page.main)
	}

	private created() {
		this.$store.dispatch('initialFetch').then(() => {
			this.pages = this.$store.getters.pages
		}, (error) => this.$toasted.error('Failed to get apps.'))
		window.addEventListener('resize', this.handleResize)
	}

	private beforeDestroy() {
		window.removeEventListener('resize', this.handleResize)
	}

	private handleResize() {
		this.width = window.innerWidth
	}

	private toggleNav() {
		this.showSidebar = !this.showSidebar
	}

	private logout() {
		localStorage.removeItem('authKey')
		localStorage.removeItem('client')
		localStorage.removeItem('clientList')
		this.$router.push({ path: 'login' })
	}
}
